var productName = 'schedulerpro';import { Mixin } from "../../../../ChronoGraph/class/BetterMixin.js";
import Store from "../../../../Core/data/Store.js";
export class ChronoStoreMixin extends Mixin([Store], (base) => class ChronoStoreMixin extends base {
}) {
}
